import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWolframmathematicaComponent } from './simple-icons-wolframmathematica.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWolframmathematicaComponent ],
    exports:      [ SimpleIconsWolframmathematicaComponent ],
    bootstrap:    []
})
export class SimpleIconsWolframmathematicaModule {}
